module.exports = __webpack_public_path__ + "img/mathieu-pro.ea28e3bb.jpg";